import { Box, CardMedia } from "@mui/material";
import { Outlet } from "react-router-dom";

const BackgroundVideo = () => {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          overflow: "hidden",
          zIndex: -100, // Ensure the video stays behind other content
          width: "100vw", // Full viewport width
          height: "100vh", // Full viewport height
        }}
      >
        <CardMedia
          component="video"
          image={require("../../assets/Pozadina.mp4")}
          autoPlay={true}
          loop={true}
          playsInline
          muted
          controls={false}
          sx={{
            minWidth: "100%", // Ensure the width fills the container
            minHeight: "100%", // Ensure the height fills the container
            objectFit: "cover", // Scale the video to cover the container while maintaining aspect ratio
            objectPosition: "center", // Keep the video centered
          }}
        />
      </Box>
      <Outlet />
    </>
  );
};

export default BackgroundVideo;
